import {
  proposalFieldLabel,
  proposalFields,
  proposalRecord,
} from "./proposal-diff";

/** Render authorized content as labelled values, never as command JSON or HTML. */
export function ProposalValue({
  value,
  depth = 0,
}: {
  value: unknown;
  depth?: number;
}) {
  if (depth > 12) return <span>Further nested content is not shown.</span>;
  if (value === undefined || value === null || value === "") {
    return <span className="italic text-pb-text-muted">Not set</span>;
  }
  if (Array.isArray(value)) {
    if (!value.length)
      return <span className="italic text-pb-text-muted">No items</span>;
    return (
      <ol className="space-y-2">
        {value.map((item, index) => (
          <li key={index} className="border-s-2 border-pb-border ps-2">
            <ProposalValue value={item} depth={depth + 1} />
          </li>
        ))}
      </ol>
    );
  }
  const record = proposalRecord(value);
  if (record) {
    const fields = proposalFields(record);
    if (!fields.length)
      return (
        <span className="italic text-pb-text-muted">
          No displayable content
        </span>
      );
    return (
      <dl className="space-y-1.5">
        {fields.map(([key, item]) => (
          <div key={key}>
            <dt className="font-medium text-pb-text-secondary">
              {proposalFieldLabel(key)}
            </dt>
            <dd className="mt-0.5">
              <ProposalValue value={item} depth={depth + 1} />
            </dd>
          </div>
        ))}
      </dl>
    );
  }
  if (typeof value === "boolean") return <span>{value ? "Yes" : "No"}</span>;
  return (
    <span className="whitespace-pre-wrap break-words [overflow-wrap:anywhere]">
      {String(value)}
    </span>
  );
}
